import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=205d76b6"
import script from "./latest.vue?vue&type=script&lang=js"
export * from "./latest.vue?vue&type=script&lang=js"
import style0 from "./latest.vue?vue&type=style&index=0&id=205d76b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports